import { SelectRequest } from '@models/selectRequest.model';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UserModel } from '@models/user.model';
import { UserRoles } from '@models/userRolesResponse.model';
import { of } from 'rxjs';
import { HelperService } from './helper.service';

@Injectable({
  providedIn: 'root'
})
export class SelectsService {
  public urlApi: string;
  public userToken: string;
  public userTokenAlt: string;
  public identity: UserModel;

  constructor(private http: HttpClient, public helper: HelperService) {
    this.urlApi = environment.urlApi;
    this.getSelects();
    this.readToken();
    this.readTokenAlt();
    this.getIdentity();
  }

  readToken() {
    if (sessionStorage.getItem('tokenCF')) {
      this.userToken = sessionStorage.getItem('tokenCF');
    } else {
      this.userToken = "";
    }
    return this.userToken;
  }

  readTokenAlt() {
    if (sessionStorage.getItem('tokenALT')) {
      this.userTokenAlt = sessionStorage.getItem('tokenALT');
    } else {
      this.userTokenAlt = '';
    }
    return this.userTokenAlt;
  }

  getIdentity() {
    return (this.identity = UserModel.fromResponse(
      JSON.parse(sessionStorage.getItem('user'))
    ));
  }

  getUserRoles() {
    let selectRequest: SelectRequest = new SelectRequest();
    const { userInfo, username } = this.identity;
    selectRequest.documentNumber = userInfo.document;
    selectRequest.documentType = userInfo.documentType;
    const headers = new HttpHeaders().set("token", environment.postgres ? this.userTokenAlt : this.userToken);
    const options = {
      params: SelectRequest.toRequest(selectRequest),
      headers
    };
    return this.http.get(`${this.urlApi}/pr_rol_usuario`, options).pipe(
      map((resp) => {
        let userRoles: Array<UserRoles> = [];
        userRoles = resp["ROL_USUARIO"] && resp["ROL_USUARIO"].length > 0
              ? resp["ROL_USUARIO"].map((user: UserRoles) => UserRoles.fromResponse(user)) 
              : [];
        return userRoles;
      })
    )
  }

  getSelects(selectType?: string) {
    const headers = new HttpHeaders(
      this.helper.getHeadersAuthorization()
    );
    const options = {
      headers,
    };
    return this.http.get<any[]>(`${this.urlApi}/commons/lists`, options).pipe(
      map((listsResponse: any[]) => {
        return (selectType) ? listsResponse['data'][selectType] : listsResponse['data'];
      })
    );
  }

  getSelectTypes(selectType: string) {
    const localStorageSelectsObject = JSON.parse(localStorage.getItem('selectsASR'));
    return (selectType && localStorageSelectsObject) ? of(localStorageSelectsObject[selectType]) : this.getSelects(selectType);
  }

}
